import { IEngineHistory } from "@/@types/engine-history";
import {
  EngineTypeRequestEnum,
  EngineTypeSolicitationEnum,
} from "@/enum/engine-history-type";
import { ColumnDef } from "@tanstack/react-table";
import { format, parseISO } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";

const typeRequestMap: Record<EngineTypeRequestEnum, string> = {
  CREATE: "Criação",
  UPDATE: "Alteração",
  DELETE: "Exclusão",
};

const typeSolicitationMap: Record<EngineTypeSolicitationEnum, string> = {
  BC: "Base de Cálculo",
  EXCEPTION: "Exceção",
};

export const columns: ColumnDef<IEngineHistory>[] = [
  {
    accessorKey: "history_id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.history_id}
      </span>
    ),
  },
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.email || "-"}
      </span>
    ),
  },
  {
    accessorKey: "responsible",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Responsável" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {row.original.responsible || "-"}
      </span>
    ),
  },
  {
    accessorKey: "type_request",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Tipo" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {typeRequestMap[row.original.type_request as EngineTypeRequestEnum] ||
          "Desconhecido"}
      </span>
    ),
  },
  {
    accessorKey: "type_solicitation",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Tipo de Solicitação" />
    ),
    cell: ({ row }) => (
      <span className="text-sm font-semibold text-gray-700">
        {typeSolicitationMap[
          row.original.type_solicitation as EngineTypeSolicitationEnum
        ] || "Desconhecido"}
      </span>
    ),
  },
  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Criado Em" />
    ),
    cell: ({ row }) => {
      const dateString = row.getValue("created_at") as string;
      if (!dateString) return (
        <span className="text-sm font-semibold text-gray-700">-</span>
      );

      try {
        const parsedDate = parseISO(dateString);
        return (
          <span className="text-sm font-semibold text-gray-700">
            {format(parsedDate, "dd/MM/yyyy HH:mm:ss", { locale: ptBR })}
          </span>
        );
      } catch (error) {
        return (
          <span className="text-sm font-semibold text-gray-700">
            Data Inválida
          </span>
        );
      }
    },
  },
  {
    id: "actions",
    header: "Ações",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
